import { useBlockProps } from '@wordpress/block-editor';

export default function Save({ attributes }) {
  const { slides, padding, colorbg } = attributes;
  const blockProps = useBlockProps.save({
    className: `${colorbg ? 'sectiongray' : ''} ${padding}`,
  });

  return (
    <>
      {slides && (
        <section {...blockProps}>
          <div class="swiper js-slider mainslider">
            <div class="swiper-wrapper">
              {slides.map((slide, index) => (
                <div key={slide.id} class="swiper-slide">
                  <div class="mainslider__item">
                    <img
                      src={slide.image.url}
                      alt={slide.image.alt}
                      fetchpriority={index === 0 ? 'high' : 'low'}
                      loading={index === 0 ? 'eager' : 'lazy'}
                      height={slide.image.height}
                      width={slide.image.width}
                    />
                    <div class="container">
                      <div class="row">
                        <div class="col col-md-8 col-lg-6">
                          <div class="mainslider__item-content">
                            {index === 0 ? (
                              <h1>{slide.title}</h1>
                            ) : (
                              <h2>{slide.title}</h2>
                            )}
                            {slide.description && (
                              <div class="mainslider__item-desc">
                                {slide.description}
                              </div>
                            )}
                            {slide.url ? (
                              <a
                                className="btn btn-square btn-mini btn-url"
                                href={slide.url}
                              >
                                Подробнее
                              </a>
                            ) : (
                              <button
                                className="btn btn-square btn-mini js-popup-open"
                                data-popup="#popup-1"
                                type="button"
                              >
                                Подробнее
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div class="swiper-pagination"></div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
          </div>
        </section>
      )}
    </>
  );
}
